export default __webpack_public_path__ + "static/media/FileWhite.a60ed826.svg";